import React, { useState, useEffect } from "react";
import "../Styles/Employee.css";
import axios from "axios";
import { getUserDetails } from "../Utility/AsyncStorage"
import { Tooltip } from 'react-tooltip'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const Employees = () => {

  var userDetails = getUserDetails();
  const [isFormVisible, setFormVisible] = useState(false);
  const [isDeleteVisible, setDeleteVisible] = useState(false);
  const [isAlreadyAssignVisible, setAlreadyAssignVisible] = useState(false); //variable to pop up already assigned list

  const [employeesData, setEmployeesData] = useState([]);
  const [assginedList, setAssignedList] = useState([]);
  const [formData, setFormData] = useState({});

  const empListData = async () => {
    console.log("empListData")
    try {
      let url = process.env.REACT_APP_BASE_URL + "/emp/listOfEmp";
      let body = {
        comp_num: userDetails.comp_num
      }
      console.log("body login", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {

            console.log("empListData", response.data.list)
            setEmployeesData(response.data.list)
          }
          else {
            console.log("empListData", response.data.msg)
          }

        }

      }).catch(error => {
        console.log("empListData", error)
      })
    } catch (error) {
      console.log("empListData", error)
    }
  }

  const todayEmpWorkingList = async (emp_id) => {
    console.log("todayEmpWorkingList", emp_id);
    setAlreadyAssignVisible([])

    try {
      let url = process.env.REACT_APP_BASE_URL + "/emp/empMachineLogs";
      let body = {
        comp_num: userDetails.comp_num,
        emp_id,
      };
      console.log("body todayEmpWorkingList", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              console.log("todayEmpWorkingList", response.data.list);
              setAssignedList(response.data.list);
            } else {
              console.log("todayEmpWorkingList", response.data.msg);
            }
          }
        })
        .catch((error) => {
          console.log("todayEmpWorkingList", error);
        });
    } catch (error) {
      console.log("todayEmpWorkingList", error);
    }
  };

  const handleSubmit = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/emp/createEmploy";
      let body = {
        emp_id: formData.emp_id,
        comp_num: userDetails.comp_num,
        name: formData.name,
        contact: formData.contact,
        address: formData.address,
        aadhar_number: formData.aadhar_number,
        rfid_number: formData.rfid_number,
        added_by: userDetails.user_id,
      };
      console.log("handleSubmit ", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              empListData();
              setFormVisible(false);
            } else {
              console.log("empListData", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("empListData", error);
        });
    } catch (error) {
      console.log("empListData", error);
    }
    setFormVisible(false);
    setFormData({});
  };

  const unAssignemp = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/emp/createEmploy";
      let body = {
        comp_num: userDetails.comp_num,
        emp_id: formData.emp_id,
        is_active: formData.is_active == "Y" ? "N" : "Y",
        added_by: userDetails.user_id
      };
      console.log("unAssignemp ", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              empListData();
              setFormVisible(false);
              setDeleteVisible(false);
            } else {
              console.log("unAssignemp", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("unAssignemp", error);
        });
    } catch (error) {
      console.log("unAssignemp", error);
    }
    setFormVisible(false);
    setDeleteVisible(false);
    setFormData({});
  };

  const editCardDetails = (cardData) => {
    console.log(cardData);
    setFormVisible(true);
    setFormData(cardData);
  };

  const handleChange = (fieldName, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  useEffect(() => {
    empListData();
  }, []);

  return (
    <div className="mainBlock">
      <div className='inlineHead' style={{ justifyContent: "space-between", alignItems: "center" }}>
        <h2 className='header-h2'>All Employees</h2>
        <div className='addBlock' onClick={() => { setFormVisible(true) }}>
          <h4>Add</h4>
          <i class="fa-solid fa-user"></i>
        </div>


        {/* <div className='downloadBox'>
            <h4>Download</h4>
            <i class="fa-regular fa-circle-down"></i>
          </div>

          <div className="search-bar">
            <i class="fa-solid fa-magnifying-glass"></i>
            <input type="text" placeholder="Search..." className="search-input" />
          </div> */}

      </div>

      <table className='workgroup-table'>
        <thead>
          <tr style={{ height: "40px", backgroundColor: "#f9f9f9", textAlign: "left" }}>
            <th style={{ borderRadius: "10px 0 0 10px", marginLeft: "10px" }}>Name</th>
            <th>Refrence Number</th>
            <th>RFID Card</th>
            <th>Aadhar Card No</th>
            <th>Address</th>
            <th>Status</th>
            <th style={{ borderRadius: "0 10px 10px 0", textAlign: "center" }} >Action</th>
          </tr>
        </thead>
        {Object.keys(employeesData).length === 0 ?
          <tr>
            {Array.from({ length: 7 }).map((_, index) => (
              <td key={index}>
                <Skeleton count={10} />
              </td>
            ))}
          </tr> :
          <tbody>
            {employeesData.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.contact}</td>
                <td>{item.rfid_number}</td>
                <td>{item.aadhar_number}</td>
                <td>{item.address}</td>
                <td style={{ textAlign: 'center' }} onClick={() => {
                  setDeleteVisible(true);
                  setFormData({ emp_id: item.emp_id, is_active: item.is_active }); //delete work group
                }}><div style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: (item.is_active === "Y" ? "green" : "red"), textAlign: "center" }}></div></td>
                <td style={{ padding: "8px", textAlign: "center" }}>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Edit"
                    style={{ margin: "5px" }} class="fa-regular fa-pen-to-square" onClick={() => editCardDetails(item)}></i>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Logs"
                    style={{ margin: "5px" }} class="fa-regular fa-share-from-square" onClick={() => {
                      setAlreadyAssignVisible(true);
                      todayEmpWorkingList(item.emp_id); //To see already work station list
                    }}></i>
                  <Tooltip id="my-tooltip" />
                </td>
              </tr>
            ))}
          </tbody>
        }
      </table>


      {isFormVisible && (
        <div className="overlay">
          <div className="form-box">
            <h2>
              {formData.hasOwnProperty("emp_id")
                ? "Edit Employees Details"
                : "Add Employees Details"}
            </h2>
            <form>
              <div className="input-group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" name="name"
                  value={formData.name}
                  onChange={(e) => handleChange("name", e.target.value)} />
              </div>
              <div className="input-group">
                <label htmlFor="contact">Refrence Number</label>
                <input type="text" id="contact" name="contact"
                  value={formData.contact}
                  onChange={(e) => handleChange("contact", e.target.value)} />
              </div>
              <div className="input-group">
                <label htmlFor="rfid_number">RFID Card</label>
                <input type="text" id="rfid_number" name="rfid_number"
                  value={formData.rfid_number}
                  onChange={(e) => handleChange("rfid_number", e.target.value)} />
              </div>
              <div className="input-group">
                <label htmlFor="address">Address.</label>
                <input type="text" id="address" name="address"
                  value={formData.address}
                  onChange={(e) => handleChange("address", e.target.value)} />
              </div>
              <div className="input-group">
                <label htmlFor="aadhar_number">Aadhar Card Number.</label>
                <input type="text" id="aadhar_number" name="aadhar_number"
                  value={formData.aadhar_number}
                  onChange={(e) => handleChange("aadhar_number", e.target.value)} />
              </div>
              <div style={{ justifyContent: "flex-end" }} className='inline'>
                <div className="submit-button" onClick={() => setFormVisible(false)}>
                  Back
                </div>
                <div className="submit-button" onClick={handleSubmit}>
                  Submit
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {isAlreadyAssignVisible && (
        <div className="overlay">
          <div className="form-box" style={{ width: "700px" }}>
            <h2>Employ Logs</h2>
            <div>
              <table className='work-table'>
                <thead style={{ borderRadius: "10px", backgroundColor: "#ddd", position: "sticky", top: 0, zIndex: 1 }}>
                  <tr>
                    <th style={{ padding: "8px", borderRadius: "10px 0 0 10px" }}>
                      Machine
                    </th>
                    <th style={{ padding: "8px" }}>
                      RFID Number
                    </th>
                    <th style={{ padding: "8px" }}>
                      Start Time
                    </th>
                    <th style={{ padding: "8px", borderRadius: "0 10px 10px 0" }}>
                      End Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {assginedList.map((item, index) => (
                    <tr key={index}>
                      <td style={{ padding: "8px" }}>
                        {item.machine_name}
                      </td>
                      <td style={{ padding: "8px" }}>
                        {item.rfid_number}
                      </td>
                      <td style={{ padding: "8px" }}>
                        {item.start_time}
                      </td>
                      <td style={{ padding: "8px" }}>
                        {item.end_time}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{ justifyContent: "flex-end" }} className="inline">
                <div
                  className="submit-button"
                  onClick={() => {
                    setAlreadyAssignVisible(false);
                    setFormData({});
                  }}
                >
                  Close
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      {isDeleteVisible && (
        <div className="overlay">
          <div className="form-box">
            <h2>
              {formData.hasOwnProperty("is_active")
                ? formData.is_active === "Y"
                  ? "Do you want to Inactive Employee?"
                  : "Do you want to Active Employee?"
                : "Do you want to Inactive Employee?"}
            </h2>
            {/* <p>Do you accept?</p> */}
            <hr></hr>
            <div>
              <div style={{ justifyContent: "flex-end" }} className="inline">
                <div
                  className="submit-button"
                  onClick={() => {
                    setDeleteVisible(false);
                    setFormData({});
                  }}
                >
                  No
                </div>
                <div
                  className="submit-button"
                  onClick={() => {
                    unAssignemp();
                  }}
                >
                  Yes
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Employees;
